import { render, staticRenderFns } from "./InputMultipleCustomers.vue?vue&type=template&id=40b20fd4"
import script from "./InputMultipleCustomers.vue?vue&type=script&lang=ts"
export * from "./InputMultipleCustomers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports